import { FunctionComponent } from 'react'
import { useNavigate } from 'react-router-dom'

import shoppingCart from '../../assets/shopping-cart.svg'
import classes from './cart-widget.module.scss'

interface Props {
  productsCount: number,
  navigatetocart: Function
}

export const CartWidget: FunctionComponent<Props> = ({ productsCount, navigatetocart }) => {
  const navigate = useNavigate()

  const navigateToCart = () => {
    // navigate('/cart')
    // navigate(pagetonavigate)
    navigatetocart()
  }

  return (
    <button className={classes.container} onClick={navigateToCart}>
      <span className={classes.productsCount}>{productsCount}</span>
      {/* <img src={shoppingCart} className={classes.shoppingCart} alt="Go to Cart" /> */}
      <svg fill="none" stroke="white" stroke-width="1.5" height="64" width="64" viewBox="-10 -7 36 36" xmlns="http://www.w3.org/2000/svg" >
          <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 3h1.386c.51 0 .955.343 1.087.835l.383 1.437M7.5 14.25a3 3 0 00-3 3h15.75m-12.75-3h11.218c1.121-2.3 2.1-4.684 2.924-7.138a60.114 60.114 0 00-16.536-1.84M7.5 14.25L5.106 5.272M6 20.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm12.75 0a.75.75 0 11-1.5 0 .75.75 0 011.5 0z"></path>
      </svg>
    </button>
  )
}
